export default __webpack_public_path__ + "static/media/cloud.fcffee55.svg";